// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteUnidades_ArquivarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/site_unidades/arquivar/{id}
 *
 * Archives a unit. No body required — the id travels in the URL.
 */
import { registerContract } from './validate'

export interface SiteUnidades_ArquivarInput {}

registerContract('SiteUnidades_ArquivarInput', {})
